module.exports = __webpack_public_path__ + "img/6.191dfa55.jpg";